/**
 * @author
 * @description 登录、获取用户信息、退出登录、清除accessToken逻辑，不建议修改
 */
// import Vue from "vue";
import { getUserInfo, getLanguagePack } from "@/api/user";
const state = () => ({
  accessToken: "",
  roleName: ["stu"], // 角色名称  admin：管理员、examAdmin：考试管理员、stu: 学生、openTea: 开考教员、gradeTea: 阅卷教员
  userInfo: {},
});
const getters = {};
// 同步方法写在这里--对应commit
const mutations = {
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken;
  },
  setRoleName(state, roleName) {
    state.roleName = roleName;
  },
  setUserInfo(state, data) {
    state.userInfo = data;
  },
};

// 异步请求写在这里--对应dispatch
const actions = {
  // 获取已登录用户信息
  // eslint-disable-next-line no-empty-pattern
  getUserInfo({}, data) {
    return new Promise((resolve, reject) => {
      getUserInfo(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 获取语言包
  getLanguagePack({}, data) {
    return new Promise((resolve, reject) => {
      getLanguagePack(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};
